<emma-text-check-modal
    *ngIf="showCheckModal"
    [items]="autocompleteItems"
    [type]="autocompleteCheckItemsModalType"
    [text]="value"
    (close)="onCancelCheckItems()"
    [icon]="autocompleteCheckIcon"
></emma-text-check-modal>
<div [ngClass]="_containerClass">
    <div class="emma-input-autocomplete--header">
        <label *ngIf="label" [class]="disabled ? 'disabled' : ''">
            {{ label }}
        </label>
        <span *ngIf="label && required && !disabled"  class="required-label" i18n>Obligatorio</span>
        <div class="d-flex align-items-center ms-auto">
            <button
                *ngIf="autocompleteCheckItems"
                class="emma-textarea--autocomplete-checker"
                emmaButton
                sizeButton="sm"
                [isCircle]="true"
                [noBg]="true"
                [hasIcon]="true"
                [onlyIcon]="true"
                (click)="onCheckItems()"
                [ngbPopover]="autocompleteCheckPopoverMsg"
                placement="top"
                triggers="hover"
                container="body"
                i18n-ngbPopover
            >
                <i class="la la-spell-check" aria-hidden="true"></i>
            </button>
            <emma-dropdown
                *ngIf="autocompletTagsItems"
                class="emma-textarea--autocomplete-dropdown"
                color="link-emmadarkblue"
                [items]="autocompleteItems"
                [buttonLabel]="autocompleteButtonLabel"
                [buttonIcon]="autocompleteButtonIcon"
                [groupBy]="autocompleteGroupBy"
                [searchable]="true"
                [disabled]="disabled"
                ($select)="onSelectAutocompleteTag($event)"
            ></emma-dropdown>
        </div>
    </div>
    <emma-input
            #inputElement
            [name]="name"
            [(ngModel)]="value"
            [type]="type"
            [inputmode]="inputmode"
            [placeholder]="placeholder"
            [required]="required"
            ($blur)="onTouched()"
            [disabled]="disabled"
        ></emma-input>
</div>